
import { Vue, Component, Prop } from 'vue-property-decorator';
import breakpointState from '@/core/responsive/breakpoints/breakpointsState.observable';
import { MAX_SM } from '@/core/config/breakpointConfig';

const mobileAspectRatio = 3 / 2;

@Component
export default class AspectRatioBlockContainer extends Vue {
    @Prop({
        required: true,
        type: Number
    }) widthOnScreen!: number;

    @Prop({
        required: true,
        type: Number
    }) aspectRatio!: number;

    @Prop({
        required: false,
        type: Object
    }) aspectRatioMargins!: { [bp: string]: number };

    get isMobile() {
        return breakpointState.isBreakpointActive(MAX_SM);
    }

    get realAspectRatio(): number {
        // For mobile, aspect-ratio is controlled from within.
        return this.isMobile ? mobileAspectRatio : this.aspectRatio;
    }

    get realWidthOnScreen(): number {
        // For mobile, widht is controlled from within.
        return this.isMobile ? 100 : this.widthOnScreen;
    }

    get margin() {
        if (!this.aspectRatioMargins) return 0;

        const activeBpDef = Object.keys(this.aspectRatioMargins).find(bpDef => breakpointState.isBreakpointActive(bpDef));
        const result = activeBpDef ? this.aspectRatioMargins[activeBpDef] : 0;
        return result;
    }

    get aspectRatioStyling() {
        const paddingPct = (1 / this.realAspectRatio) * 100;
        return ({
            paddingBottom: `calc(${paddingPct}% - ${this.margin}px)`
        });
    }
}
